import { ParcellaireViticoleComponent } from "./parcellaire-viticole.component";

export const PARCELLAIRE_VITICOLE_ROUTES = [
    {
        path: '',
        component: ParcellaireViticoleComponent,
        data: {
            role: 'DECLARATION_INVENTAIRE_VERGER_LECTURE',
             menu: {
                libelle: 'Parcellaire'
            }
        }
    }
];
